module.exports = __webpack_public_path__ + "static/media/boat-img-17.26549348.jpg";